import _ from 'lodash';
import React from 'react';
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../common/components/form/form.module';

export const PollsBasicInfoComponent = ({
    selectPolls, handleInnerFormChange, PollTypeList, accountTypesListLoading, accountListLoading, accountsList, accountTypesList, policyOwnerType
}: any) => {

    return (
        <>
            <AccordionContainer
                child={
                    <div className='grid md:grid-cols-3 lg:grid-cols-4 gap-4'>

                        <InputContainer
                            label="Level"
                            labelField="Text"
                            list={policyOwnerType}
                            isDisabled={selectPolls?.Id && selectPolls?.OwnerLevelId}
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'OwnerLevelId'
                                );
                            }}
                            optionName='Choose Level'
                            type="select"
                            value={selectPolls?.OwnerLevelId}
                            valueField="Value"
                        />
                        <InputContainer
                            label="Account Type"
                            labelField="Name"
                            isLoading={accountTypesListLoading}
                            list={accountTypesList}
                            isDisabled={selectPolls?.Id && selectPolls?.OwnerTypeId}
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'OwnerTypeId',
                                );
                            }}
                            optionName='Choose Account Type'
                            type="select"
                            value={selectPolls?.OwnerTypeId}
                            valueField="Id"
                        />
                        <InputContainer
                            label="Account Name"
                            labelField="Name"
                            isLoading={accountListLoading}
                            list={accountsList}
                            isDisabled={selectPolls?.Id && selectPolls?.OwnerAccountId}
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'OwnerAccountId',
                                );
                            }}
                            optionName='Choose Account Name'
                            type="select"
                            value={selectPolls?.OwnerAccountId}
                            valueField="Id"
                        />
                        <InputContainer
                            label="Title"
                            labelField="Title"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Title'
                                );
                            }}
                            type="text"
                            value={selectPolls?.Title}
                        />

                        <InputContainer
                            label="Description"
                            labelField="Description"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'Description'
                                );
                            }}
                            type="text"
                            value={selectPolls?.Description}
                        />


                        <InputContainer
                            label="ExpiresAt"
                            labelField="ExpiresAt"
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'ExpiresAt'
                                );
                            }}
                            type="date"
                            value={selectPolls?.ExpiresAt}
                        />

                        <InputContainer
                            label="Poll Type"
                            labelField="Text"
                            list={PollTypeList}
                            onValueChange={(event: any, newValue: any) => {
                                handleInnerFormChange(
                                    event.target.value,
                                    'PollTypeId',
                                );
                            }}
                            optionName='Choose Entity Type'
                            type="select"
                            value={selectPolls?.PollTypeId}
                            valueField="Value"
                        />
                       

                        <InputContainer

                            label="Approved"
                            name="IsApproved"
                            onValueChange={(event: any) => {
                                handleInnerFormChange(
                                    event,
                                    'IsApproved'
                                )
                            }}
                            type="checkbox"
                            value={selectPolls?.IsApproved}
                        />
                        
                    </div>
                }
                expandedPanel="BasicInfo"
                headerTitle="Basic Info"
            />
        </>
    );
}

export default PollsBasicInfoComponent;
